import { actions, helpers, selectors } from 'app-webtech-core';
import { ccNextSubmenu, internalResetCaptionsSettings } from 'app-modules/player/actions';
import { DPAD_RIGHT } from './types';

const remoteControllerDPadRightButtonAction = helpers.actions.actionCreator(DPAD_RIGHT);

export const remoteControllerDPadRightButtonThunkAction = () => async (dispatch, getState) => {
  const state = getState();
  const {
    isCCMenuOpen,
    ccMenuSelectedIndexes,
    currentCCMenu,
    currentCCMenuName,
  } = selectors.player.properties(state);
  const location = selectors.location.page(state);
  const focusedArea = selectors.application.focusedArea(state);
  // checks to see if the cc settings menu is open
  if (!isCCMenuOpen) {
    if (location === 'Vod' || location === 'Watch') {
      if (focusedArea === 'CATEGORY_LIST') {
        dispatch(actions.application.setFocusedArea('SCHEDULE_LINES'));
      }
      await dispatch(remoteControllerDPadRightButtonAction());
    }
  } else {
    const newIndex = ccMenuSelectedIndexes.concat(0);
    const menuObj = helpers.getCCMenu(
      newIndex,
      currentCCMenu,
      currentCCMenuName,
      state.playerinternal.captionsSettings.showReset,
    );
    if (menuObj.currentCCMenuName === 'reset') {
      await dispatch(internalResetCaptionsSettings());
    } else {
      await dispatch(ccNextSubmenu());
    }
  }
};
